export const DOCUMENT_UPLOAD_DESTINATION_CURRENT = 'upload_current'

export const DOCUMENT_UPLOAD_DESTINATION_ALL = 'upload_all'
